import React, { useEffect, useState } from 'react'
import http, { URL_S3 } from '../../../../config/BaseUrl'

const GifModal = (props) => {
  const [propsItems, setPropsItem] = useState([])
  const [allGif, setAllGif] = useState([])
  const [submitClose, setSubmitClose] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedAll, setSelectedAll] = useState(false)


  const GifItemList = async () => {
    try {
      setLoading(true)
      await http.get("gif-list").then((res) => {
        if (res.data.status === true) {
          setAllGif(res.data.gifList)
          setLoading(false)
        }

      }).catch((err) => {
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }

  const handleSubmit = () => {
    if (propsItems) {
      props.setData(propsItems)
    }
  }

  useEffect(() => {
    if (propsItems.length != props.selectGifItems.length) {
      setPropsItem(props.selectGifItems)

    }
    if (props.selectGifItems.length > 0) {
      setSelectedAll(true)
    }
    else {
      setSelectedAll(false)
    }

    GifItemList()

  }, [props])


  const changeValue = (item) => {
    let copyItem = [...propsItems]
    let IndexOfItem = copyItem.findIndex(data => data.id === item.id)

    if (IndexOfItem >= 0) {
      copyItem.splice(IndexOfItem, 1)
      setPropsItem(copyItem)
    }
    else {
      copyItem = [...copyItem, item]
      setPropsItem(copyItem)

    }

    if (copyItem.length > 0) {
      setSubmitClose(true)
    }
    else {
      setSubmitClose(false)
    }

  }

  const selectAllData = () => {
    let copyItem = [...propsItems]
    let copyData = [...allGif]
    if (!selectedAll) {
      copyData.forEach(itemData => {
        let dataSet = { id: itemData.id, photo: itemData.image }
        let IndexOfItem = copyItem.findIndex(data => data.id === dataSet.id)

        if (IndexOfItem < 0) {
          copyItem = [...copyItem, dataSet]
          setPropsItem(copyItem)
        }
      })
      setSelectedAll(true)

    }
    else {
      copyData.forEach(itemData => {
        let dataSet = { id: itemData.id, photo: itemData.image }
        let IndexOfItem = copyItem.findIndex(data => data.id === dataSet.id)

        if (IndexOfItem >= 0) {
          copyItem.splice(IndexOfItem, 1)
          setPropsItem(copyItem)
        }
      })

      setSelectedAll(false)
    }
    if (copyItem.length > 0) {
      setSubmitClose(true)
    }
    else {
      setSubmitClose(false)
    }

  }

  return (
    <div className="modal fade" id="props-filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">3 in 1 Animation</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="tab-content template-content" id="email-temp-tabContent">
              <div
                className="tab-pane fade show active"
                id="email-temp-home"
                role="tabpanel"
                aria-labelledby="email-temp-home-tab"
              >
                <div className="standared-template">
                  <div className="row">

                    {loading ?
                      <div className="text-center col-md-12">
                        <span className="spinner-border" role="status" aria-hidden="true"></span>
                      </div>
                      : allGif && allGif.map((items) => {
                        return (
                          <div
                            key={items.id}
                            className="my-2 col-md-2"
                            onClick={e => changeValue({
                              id: items.id,
                              photo: items.photo,
                              image: items.preview_image,
                              settings: {
                                gifId: items.id,
                                number_of_frame: 3,
                                interval_count_down: 3,
                                playback_speed: 2,
                                individual_photo: "disabled",
                                show_overlay: false,
                                mirror_live: false,
                              }
                            })}
                          >
                            <div className={`template-item ${propsItems && propsItems.findIndex(item => item.id === items.id) >= 0 && 'active-template'}`}>
                              <img src={`${URL_S3}image/gif/preview_image/${items.preview_image}`} alt="template-1" className="img-fluid" />
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer justify-content-between">
            <div className="left-alignment">
              <button type="button" className="px-5 m-1 btn btn-secondary radius-30" onClick={selectAllData}>
                {
                  !selectedAll
                    ? "Select All"
                    : "Remove All"
                }
              </button>
            </div>
            <div className="right-alignment">
              <button type="button" className="px-5 m-1 btn btn-secondary radius-30" data-dismiss="modal">Close</button>
              <button type="button" className="px-5 m-1 btn btn-primary radius-30" onClick={handleSubmit} data-dismiss={submitClose && "modal"}>Save changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GifModal
